// extracted by mini-css-extract-plugin
module.exports = {"container":"__404_container__nZjTy","h1":"__404_h1__8gblx","p":"__404_p__QX9VK","button":"__404_button__Na7s0"};